import { toast } from 'react-toastify';

const errorMessage = (message = 'An error occurred') => toast.error(message, {
  position: 'bottom-center',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
});

const clearAllToast = () => toast.dismiss();

export {
  errorMessage,
  clearAllToast,
};
